// src/modules/assetManagement/useMockQuery.ts
// Runs an async loader and re-runs it whenever the mock store changes. Keeps the last data while reloading.
import { useCallback, useEffect, useRef, useState } from "react";
import { subscribe } from "./mockDb";

export function useMockQuery<T>(loader: () => Promise<T>, deps: unknown[]) {
  const [data, setData] = useState<T | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const requestId = useRef(0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const load = useCallback(loader, deps);

  const run = useCallback(() => {
    const id = ++requestId.current;
    setLoading(true);
    load()
      .then((result) => {
        if (id === requestId.current) setData(result);
      })
      .finally(() => {
        if (id === requestId.current) setLoading(false);
      });
  }, [load]);

  useEffect(() => {
    run();
    return subscribe(run);
  }, [run]);

  return { data, loading, initialLoading: loading && data === undefined };
}
